import { Component, OnInit } from '@angular/core';
import { Course, CourseService } from 'src/app/core/http/course/course.service';



@Component({
  selector: 'app-courses',
  templateUrl: './courses.component.html',
  styleUrls: ['./courses.component.css']
})

export class CoursesComponent implements OnInit {

  courses: Course[];
  privateCourse = false;
  constructor(private CourseService: CourseService ) {

  }

  ngOnInit() {
    
  }

  

}
